function variantIdFromDom() {
  var sel = document.querySelector("select[data-variant-select]");
  if (sel && sel.value) return sel.value;
  var inp = document.querySelector('#AddToCartForm input[name="id"]');
  return inp && inp.value ? inp.value : null;
}

export function initVariantPanelToggle(rootAttr, panelAttr, headingAttr) {
  function syncPanelsForRoot(root) {
    var heading = headingAttr ? root.querySelector("[" + headingAttr + "]") : null;
    var panels = root.querySelectorAll("[" + panelAttr + "]");
    var id = variantIdFromDom();
    if (!id) return;

    var match = root.querySelector('[' + panelAttr + '="' + id + '"]');
    panels.forEach(function (p) {
      p.hidden = true;
    });

    if (match) {
      match.hidden = false;
      if (heading) heading.hidden = false;
      root.hidden = false;
    } else {
      if (heading) heading.hidden = true;
      root.hidden = true;
    }
  }

  var boundFlagKey = "__variantPanelsBound_" + rootAttr;
  if (!window[boundFlagKey]) {
    window[boundFlagKey] = true;
    // chosen-js fires its change notification via jQuery's `.trigger("change")`, which never
    // reaches a native addEventListener("change", ...) — jQuery only walks its own handler
    // registry (and delegated jQuery handlers) when dispatching a synthetic trigger like this.
    $(document).on("change", "select[data-variant-select]", function () {
      document.querySelectorAll("[" + rootAttr + "]").forEach(syncPanelsForRoot);
    });
  }

  document.querySelectorAll("[" + rootAttr + "]").forEach(syncPanelsForRoot);
}
